<template>
    <div>
        <h1>Neuen PCR Cycler verbinden</h1>

        Hier haben Sie die M&ouml;glichkeit, selbstst&auml;ndig weitere
        Cycler zu Ihrem Account hinzuzuf&uuml;gen.<br/><br/>
        <input v-model="serial" type="number" utofocus ref="sn" placeHolder="Seriennummer" />
    </div>
</template>
<script>
export default ({
    mounted() {
        this.$refs.sn.focus()
    },
    data() {
        return {
            serial: null,
        }
    }
})
</script>
